import { Action } from "redux"

import * as actions from "./actions"

export const initialState: Navigation.Navigation = {
    selectedTab: 0,
    workspaces: {
        filter: "",
        pageSize: 25,
        workspaces: [],
        offset: 0,
        hasMore: true,
        isLoading: true,
    },
    smartlists: {
        filter: "",
        pageSize: 25,
        Private: {
            smartlists: [],
            offset: 0,
            hasMore: true,
            isLoading: true,
        },
        SharedByMe: {
            smartlists: [],
            offset: 0,
            hasMore: true,
            isLoading: true,
        },
        SharedWithMe: {
            smartlists: [],
            offset: 0,
            hasMore: true,
            isLoading: true,
        },
    },
}

const handlers: {
    [action: string]: (
        state: Navigation.Navigation,
        props: Action,
    ) => Navigation.Navigation
} = {
    [actions.SET_INITIALIZED]: (state): Navigation.Navigation => ({
        ...state,
        initialized: true,
    }),

    [actions.RECEIVE_WORKSPACES]: (
        state,
        { workspaces, offset, hasMore }: actions.ReceiveWorkspacesAny,
    ): Navigation.Navigation => ({
        ...state,
        workspaces: {
            ...state.workspaces,
            workspaces: state.workspaces.workspaces.concat(...workspaces),
            offset,
            isLoading: false,
            hasMore,
        },
    }),

    [actions.FILTER_WORKSPACES]: (
        state,
        { filter }: actions.FilterWorkspacesAny,
    ): Navigation.Navigation => ({
        ...state,
        workspaces: {
            ...initialState.workspaces,
            filter,
            isLoading: true,
        },
    }),

    [actions.FILTER_SMARTLISTS]: (
        state,
        { filter }: actions.FilterSmartlists,
    ): Navigation.Navigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            filter,
            Private: {
                ...state.smartlists.Private,
                isLoading: true,
                hasMore: true,
            },
            SharedByMe: {
                ...state.smartlists.SharedByMe,
                isLoading: true,
                hasMore: true,
            },
            SharedWithMe: {
                ...state.smartlists.SharedWithMe,
                isLoading: true,
                hasMore: true,
            },
        },
    }),

    [actions.REQUEST_SMARTLISTS]: (state): Navigation.Navigation => ({
        ...state,
        smartlists: {
            ...initialState.smartlists,
            filter: state.smartlists.filter,
        },
    }),

    [actions.REQUEST_SMARTLISTS_PRIVATE]: (state): Navigation.Navigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            Private: {
                ...state.smartlists.Private,
                isLoading: true,
            },
        },
    }),

    [actions.RECEIVE_SMARTLISTS_PRIVATE]: (
        state,
        { smartlists, offset, hasMore }: actions.ReceiveSmartlistsGeneric,
    ): Navigation.Navigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            Private: {
                ...state.smartlists.Private,
                smartlists: [
                    ...state.smartlists.Private.smartlists,
                    ...smartlists,
                ],
                offset,
                hasMore,
                isLoading: false,
            },
        },
    }),

    [actions.REQUEST_SMARTLISTS_SHARED_BY_ME]: (
        state,
    ): Navigation.Navigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            SharedByMe: {
                ...state.smartlists.SharedByMe,
                isLoading: true,
            },
        },
    }),

    [actions.RECEIVE_SMARTLISTS_SHARED_BY_ME]: (
        state,
        { smartlists, offset, hasMore }: actions.ReceiveSmartlistsGeneric,
    ): Navigation.Navigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            SharedByMe: {
                ...state.smartlists.SharedByMe,
                smartlists: [
                    ...state.smartlists.SharedByMe.smartlists,
                    ...smartlists,
                ],
                offset,
                hasMore,
                isLoading: false,
            },
        },
    }),

    [actions.REQUEST_SMARTLISTS_SHARED_WITH_ME]: (
        state,
    ): Navigation.Navigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            SharedWithMe: {
                ...state.smartlists.SharedWithMe,
                isLoading: true,
            },
        },
    }),

    [actions.RECEIVE_SMARTLISTS_SHARED_WITH_ME]: (
        state,
        { smartlists, offset, hasMore }: actions.ReceiveSmartlistsGeneric,
    ): Navigation.Navigation => ({
        ...state,
        smartlists: {
            ...state.smartlists,
            SharedWithMe: {
                ...state.smartlists.Private,
                smartlists: [
                    ...state.smartlists.SharedWithMe.smartlists,
                    ...smartlists,
                ],
                offset,
                hasMore,
                isLoading: false,
            },
        },
    }),

    [actions.UPDATE_SELECTED_TAB]: (
        state,
        { tab }: actions.TabAction,
    ): Navigation.Navigation => ({ ...state, selectedTab: tab }),
}

export default function reducer(
    state: Navigation.Navigation = initialState,
    action: Action,
): Navigation.Navigation {
    const handler: (
        state: Navigation.Navigation,
        action: Action,
    ) => Navigation.Navigation = handlers[action.type]
    return handler ? handler(state, action) : state
}
